import { defineComponent as _defineComponent } from 'vue'
import { ref as _ref } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { onMounted } from 'vue';
import { TagDto, TermService } from '@/api';
import i18n from '@/i18n';
import Term from '@/components/terms/Term.vue';
import { VAutocomplete } from 'vuetify/lib';

interface TermSelectorProps {
  hint?: string;
  returnObject?: boolean;
}
type TermSelectorEmits = {
  (event: 'input', tags: TagDto[] | null): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Term-Selector',
  props: {
  hint: { default: i18n.t('terms.hint') },
  returnObject: { type: Boolean, default: true },
  value: null
},
  emits: ["input"],
  setup(__props, { emit: emits }) {

const props = __props;




const { value: selectedTerms } = __MACROS_useVModel(["value", undefined, "input"]);

let terms = _ref<TagDto[]>([]);
let loading = _ref(false);
const searchString = _ref('');
const termSelector = _ref<{ blur:() => void } | null>(null);

/**
 * Get different item icon based on content value
 * @param hasValue true if not empty
 */
const customItemIcon = (hasValue: boolean) => (hasValue ? 'icon-check-square-fill' : 'icon-check-square-outline-empty');

/**
 * Close v-autocomplete dropdown
 */
const closeMenu = () => {
  termSelector.value?.blur();
};

/**
 * Clear selected terms & fetched data
 */
const clear = () => {
  selectedTerms.value = [];
  emits('input', selectedTerms.value);
  closeMenu();
};

/**
 * Fetch complete term data
 */
const fetchTerms = async () => {
  loading.value = true;
  const { data } = await TermService.getAllTerm({ itemsPerPage: -1 });
  terms.value = data;
  loading.value = false;
};

onMounted(() => {
  fetchTerms();
});

return { __sfc: true,props, emits, selectedTerms, terms, loading, searchString, termSelector, customItemIcon, closeMenu, clear, fetchTerms, _ref, __MACROS_useVModel, onMounted, TagDto, TermService, i18n, Term, VAutocomplete }
}

})